import styled from 'styled-components'
import { color, font, fontSize } from '../../theme'
import { InputElem } from '.'

export const Container = styled.div`
  width: 100%;
  margin-bottom: 20px;
`

export const ErrorIcon = styled.img`
  width: 20px;
  height: 20px;
  margin-left: 10px;
  border: 0;
  outline: 0;
  object-fit: contain;
`

export const InputContainer = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
`

export const InputElement = styled.input<InputElem>`
  flex: 1;
  max-width: ${({ isError }) => (isError ? '340px' : '360px')};
  height: 100%;
  padding: 0 20px;
  border: 0;
  outline: 0;
  border-radius: 5px;
  background-color: ${({ backgroundColor, isError, errorBackgroundColor }) =>
    isError ? errorBackgroundColor || color.veryLightPink : backgroundColor || color.whiteBlue};
  font-family: ${font.sansationRegular};
  font-size: ${fontSize.regular};
  transition: width linear 0.1s;
  &::placeholder {
    color: ${({ placeholderColor }) => placeholderColor || color.grey};
  }
  &:focus {
    background-color: ${({ activeColor, isError }) =>
      isError ? color.veryLightPink : activeColor || color.whiteBlue};
  }
`
